import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const result = await login(formData, 'user');
    
    if (result.success) {
      navigate('/');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-2 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        {/* Back to Home Link */}
        <div className="mb-6">
          <Link to="/" className="text-body hover:text-primary transition-colors inline-flex items-center text-sm font-medium">
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </Link>
        </div>

        {/* Login Card */}
        <div className="rounded-sm border border-stroke bg-white shadow-default">
          <div className="border-b border-stroke px-7 py-4">
            <h3 className="font-medium text-black text-2xl">
              Sign In
            </h3>
            <p className="text-sm text-body mt-1">Welcome back! Please enter your details.</p>
          </div>

          <div className="p-7">
            <form onSubmit={handleSubmit}>
              <div className="mb-5.5">
                <label className="form-label">
                  Email Address <span className="text-meta-1">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="form-control"
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
              </div>

              <div className="mb-5.5">
                <div className="flex justify-between items-center mb-3">
                  <label className="form-label mb-0">
                    Password <span className="text-meta-1">*</span>
                  </label>
                  <Link to="/forgot-password" className="text-sm text-yellow-400 hover:underline hover:!text-yellow-500">
                    Forgot Password?
                  </Link>
                </div>
                <input
                  type="password"
                  name="password"
                  required
                  className="form-control"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="btn !bg-yellow-400 text-white !font-bold w-full flex justify-center py-3 hover:!bg-yellow-500"
              >
                {loading ? (
                  <span className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Signing in...
                  </span>
                ) : (
                  'Sign In'
                )}
              </button>

              <div className="mt-6 text-center">
                <p className="text-body">
                  Don't have an account?{' '}
                  <Link to="/register" className="text-yellow-400 hover:underline hover:!text-yellow-400 font-medium">
                    Sign Up
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

